const VasState = {
    vasdata: [],
    vaspower: [],
    vascable: []
};

export default VasState;
